import {defineField, defineType} from 'sanity'
import {MdOutlineAutoAwesomeMosaic} from 'react-icons/md'

export default defineType({
  name: 'featured-cruises-section',
  title: 'Featured Cruises Section',
  type: 'object',
  icon: MdOutlineAutoAwesomeMosaic,
  fields: [
    defineField({
      name: 'title',
      type: 'string',
      validation: (rule) => rule.required(),
    }),
    defineField({
      name: 'content',
      type: 'portableText',
    }),
    defineField({
      name: 'filters',
      type: 'cruise-filters',
      title: 'Cruise Filters',
      description: 'Optionally add filters to narrow down the cruise search results.',
    }),
  ],
  preview: {
    select: {
      title: 'title',
    },
    prepare({title}) {
      return {
        title: title || 'Featured Cruises Section',
      }
    },
  },
})
